import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_arrow_down.svg';
import Icon, { IconProps } from './icon';

const IconArrowDown = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconArrowDown;
